export default __webpack_public_path__ + "static/media/reporting_body.f7ce37e0.png";